import { useStore } from '../store/store';

/**
 * Shown once, on the very first launch, and never again.
 *
 * Gated on the `onboarded` flag in localStorage. Clearing site data brings it
 * back; nothing else does.
 */
export function Onboarding() {
  const store = useStore();

  return (
    <div className="app">
      <header className="topbar">
        <h1 className="card-title">PEMF Controller</h1>
      </header>

      <main className="main">
        <div className="card">
          <h2 className="card-title">Before you start</h2>
          <p className="muted">
            This app controls a self-built PEMF device. It isn't a medical device and hasn't been
            tested or approved by anyone.
          </p>

          <div className="banner danger" style={{ marginTop: 14 }}>
            <span aria-hidden="true">⚠</span>
            <div>
              <strong>Don't use this device if you have:</strong>
              <ul className="caveat-list" style={{ marginTop: 6 }}>
                <li>A pacemaker or implanted defibrillator</li>
                <li>A vagus nerve stimulator or deep brain stimulator</li>
                <li>A cochlear implant or insulin pump</li>
                <li>Metal implants in the area you'd be treating</li>
              </ul>
              <div className="faint" style={{ marginTop: 8 }}>
                A pulsed magnetic field can interfere with implanted electronics and can heat or
                move metal. Turning the intensity down doesn't change that.
              </div>
            </div>
          </div>

          <p className="muted">
            Everything else is your call. You can see the frequencies worth being careful with any
            time by tapping <strong>⚠</strong> at the top of the screen.
          </p>

          <button
            className="btn primary"
            style={{ width: '100%', marginTop: 8 }}
            onClick={store.completeOnboarding}
          >
            Got it
          </button>
        </div>
      </main>
    </div>
  );
}
